
import { Footer } from "@/components/Footer";
import { Header } from "@/components/Header";
import { SectionTitle } from "@/components/SectionTitle";
import { Link } from "react-router-dom";
import { blogPosts } from "@/data/blogPosts";
import { PageTitle } from "@/components/PageTitle";

const Sitemap = () => {
  return (
    <div className="flex flex-col min-h-screen">
      <PageTitle title="Sitemap – Asrani Dental Clinic" />
      <Header />
      <main className="flex-grow pt-24 lg:pt-28 bg-dental-offwhite">
        <div className="container-custom py-12 md:py-16">
          <SectionTitle
            title="Sitemap"
            subtitle="Find everything you need on our website"
            alignment="left"
          />
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 mt-12">
            <div>
              <h2 className="text-2xl font-serif font-medium mb-6 text-gray-800">Main Pages</h2>
              <ul className="space-y-3">
                <li>
                  <Link to="/" className="text-dental-highlight hover:underline">Home</Link>
                </li>
                <li>
                  <Link to="/about" className="text-dental-highlight hover:underline">About Us</Link>
                </li>
                <li>
                  <Link to="/services" className="text-dental-highlight hover:underline">Our Services</Link>
                </li>
                <li>
                  <Link to="/clinics" className="text-dental-highlight hover:underline">Our Clinics</Link>
                </li>
                <li>
                  <Link to="/gallery" className="text-dental-highlight hover:underline">Gallery</Link>
                </li>
                <li>
                  <Link to="/blog" className="text-dental-highlight hover:underline">Blog</Link>
                </li>
                <li>
                  <Link to="/contact" className="text-dental-highlight hover:underline">Contact Us</Link>
                </li>
              </ul>
            </div>

            <div>
              <h2 className="text-2xl font-serif font-medium mb-6 text-gray-800">Appointment Booking</h2>
              <ul className="space-y-3">
                <li>
                  <Link to="/dental-appointment-booking" className="text-dental-highlight hover:underline">Book Appointment</Link>
                </li>
              </ul>
            </div>
            
            <div>
              <h2 className="text-2xl font-serif font-medium mb-6 text-gray-800">General Dental Services</h2>
              <ul className="space-y-3">
                <li>
                  <Link to="/services/general-dentistry-in-nagpur" className="text-dental-highlight hover:underline">General Dentistry</Link>
                </li>
                <li>
                  <Link to="/services/pediatric-dentistry-in-nagpur" className="text-dental-highlight hover:underline">Pediatric Dentistry</Link>
                </li>
                <li>
                  <Link to="/services/teeth-cleaning-in-nagpur" className="text-dental-highlight hover:underline">Teeth Cleaning</Link>
                </li>
                <li>
                  <Link to="/services/gum-cleaning-in-nagpur" className="text-dental-highlight hover:underline">Gum Cleaning</Link>
                </li>
                <li>
                  <Link to="/services/painless-rct-in-nagpur" className="text-dental-highlight hover:underline">Painless RCT</Link>
                </li>
                <li>
                  <Link to="/services/single-day-rct-in-nagpur" className="text-dental-highlight hover:underline">Single Day RCT</Link>
                </li>
                <li>
                  <Link to="/services/wisdom-tooth-removal-in-nagpur" className="text-dental-highlight hover:underline">Wisdom Tooth Removal</Link>
                </li>
                <li>
                  <Link to="/services/laser-dentistry-in-nagpur" className="text-dental-highlight hover:underline">Laser Dentistry</Link>
                </li>
                <li>
                  <Link to="/services/tmj-tmd-in-nagpur" className="text-dental-highlight hover:underline">TMJ/TMD Treatment</Link>
                </li>
              </ul>
            </div>

            <div>
              <h2 className="text-2xl font-serif font-medium mb-6 text-gray-800">Cosmetic & Restorative</h2>
              <ul className="space-y-3">
                <li>
                  <Link to="/services/cosmetic-dentistry-in-nagpur" className="text-dental-highlight hover:underline">Cosmetic Dentistry</Link>
                </li>
                <li>
                  <Link to="/services/smile-makeover-in-nagpur" className="text-dental-highlight hover:underline">Smile Makeover</Link>
                </li>
                <li>
                  <Link to="/services/tooth-whitening-in-nagpur" className="text-dental-highlight hover:underline">Teeth Whitening</Link>
                </li>
                <li>
                  <Link to="/services/dental-veneers-in-nagpur" className="text-dental-highlight hover:underline">Dental Veneers</Link>
                </li>
                <li>
                  <Link to="/services/dental-implants-in-nagpur" className="text-dental-highlight hover:underline">Dental Implants</Link>
                </li>
                <li>
                  <Link to="/services/full-mouth-implants-in-nagpur" className="text-dental-highlight hover:underline">Full Mouth Implants</Link>
                </li>
                <li>
                  <Link to="/services/crowns-bridges-in-nagpur" className="text-dental-highlight hover:underline">Crowns & Bridges</Link>
                </li>
                <li>
                  <Link to="/services/orthodontics-in-nagpur" className="text-dental-highlight hover:underline">Orthodontics</Link>
                </li>
                <li>
                  <Link to="/services/invisalign-in-nagpur" className="text-dental-highlight hover:underline">Invisalign</Link>
                </li>
              </ul>
            </div>
            
            <div>
              <h2 className="text-2xl font-serif font-medium mb-6 text-gray-800">Blog Posts</h2>
              <ul className="space-y-3 max-h-80 overflow-y-auto">
                {blogPosts.slice(0, 10).map((post) => (
                  <li key={post.id}>
                    <Link to={`/blog/${post.slug}`} className="text-dental-highlight hover:underline">
                      {post.title}
                    </Link>
                  </li>
                ))}
                {blogPosts.length > 10 && (
                  <li className="text-dental-muted text-sm">
                    ... and {blogPosts.length - 10} more blog posts
                  </li>
                )}
              </ul>
            </div>
            
            <div>
              <h2 className="text-2xl font-serif font-medium mb-6 text-gray-800">Legal & Information</h2>
              <ul className="space-y-3">
                <li>
                  <Link to="/privacy-policy" className="text-dental-highlight hover:underline">Privacy Policy</Link>
                </li>
                <li>
                  <Link to="/terms-of-service" className="text-dental-highlight hover:underline">Terms of Service</Link>
                </li>
                <li>
                  <Link to="/sitemap" className="text-dental-highlight hover:underline">Sitemap</Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Sitemap;
